import { formatPrice } from '@/lib/utils';

interface DiscountSummaryProps {
  discountBreakdown: Array<{
    productId: number;
    productName: string;
    discountAmount: number;
    discountType: string;
    threshold: number;
    quantity: number;
  }>;
  totalDiscount: number;
}

export function DiscountSummary({ discountBreakdown, totalDiscount }: DiscountSummaryProps) {
  if (totalDiscount === 0) return null;

  return (
    <div className="bg-green-50 dark:bg-green-900/20 rounded-lg p-4 border border-green-200 dark:border-green-800">
      <h4 className="text-sm font-semibold text-green-800 dark:text-green-300 mb-3 flex items-center gap-2">
        🎉 Active Discounts
      </h4>
      <div className="space-y-2">
        {discountBreakdown.map((discount, index) => (
          <div key={index} className="flex justify-between items-start text-sm">
            <div className="flex-1">
              <p className="font-medium text-green-700 dark:text-green-400">
                {discount.productName}
              </p>
              <p className="text-green-600 dark:text-green-500 text-xs">
                {discount.quantity} items × {discount.discountType === 'percentage' 
                  ? `${discount.discountAmount}% off`
                  : `${formatPrice(discount.discountAmount)} off`}
              </p>
            </div>
            <span className="font-semibold text-green-700 dark:text-green-400">
              -{formatPrice(discount.discountAmount)}
            </span>
          </div>
        ))}
      </div>
      <div className="mt-3 pt-3 border-t border-green-200 dark:border-green-700">
        <div className="flex justify-between items-center">
          <span className="font-semibold text-green-800 dark:text-green-300">
            Total Savings:
          </span>
          <span className="font-bold text-green-700 dark:text-green-400 text-lg">
            -{formatPrice(totalDiscount)}
          </span>
        </div>
      </div>
    </div>
  );
}